import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
import {
  getGas,
  getTxHistoryEth,
  getTxHistoryErc,
  w_l_contents,
  wallet_send,
  api_config,
  user_swap,
  user_lockup_list,
  api_staking,
  available_token,
  my_l_attend,
  my_l_recommend,
  my_point_history,
  check_address,
  w_r_my_point,
  balance_pli,
  exchange_pli,
  lotto_price,
  send_transaction,
  send_transaction_tron , 
  send_transaction_w3p , 
  balance_all,
  w_l_popup,
  user_attend,
  staking_token,
  psite,
  event_add  ,
  market_payed

} from '../api/index'
import {
  auth_code,
  staff_act, 
  market_act , 
  loginG , 
  authsend,
  nft_proc, 

  login,
  signup,
  userInfo,
  sendVerifyCode,
  verify,
  withdraw,
  auth_sms,
  auth_sms_confirm,
  auth_sms_complete,
  mailcheck , 
  register_push ,

  kyc_req , 
  kyc_chk ,
  card_activa ,
  card_info ,
  recharge,
  recharge_chk,
  tradeHistory,
  card_order,


} from '../api/user'
import {
  getEthBalance,
  getTokenBalance,
  getTokenPrice,
  getRawTx,
  config
} from '../api/token'
import {
  w_d_lotto_user_num,
  w_cu_lotto_user_num,
  w_l_lotto_user_num,
  w_l_lotto_num,
  w_lotto_home,
  w_l_lotto_no,
  w_lotto_order_result,
  w_c_lotto_order2,
  w_l_lotto_amt,
  lotto_order
} from '../api/lotto'

Vue.use(Vuex)
// alert(location.href.indexOf('localhost'))
// alert(location.href.indexOf('lassa'))
// alert( location.href.indexOf('lassa') > -1 || location.href.indexOf('localhost') > -1  )



// alert(( location.href.indexOf('lassa') > -1 || location.href.indexOf('localhost') > -1  ))
var ls = new SecureLS({ isCompression: false })
export default new Vuex.Store({
  /* eslint-disable */
  // plugins: [ vuexSession.plugin,vuexLocal.plugin ],
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      },
      reducer(val) {
        if (val.is_login === false) {
          // return empty state when user logged out
          return {}
        }
        return val
      }
    })
  ],
  state: {
    
    staff : ( location.href.indexOf('lassa') > -1 || location.href.indexOf('localhost') > -1  ) ,  
   // staff : false,  
    result :{} ,  

    toast: {
      toast: false,
      toast_msg: '',
      timeout: null
    },
    modal: {
      on: false,
      msg: ''
    },
    wlabel: {
      logo  : 'logo.svg' , 
      name  : 'plapay' , 
    } ,     
    loading: false,
    is_login: false,
    activeMenu: '',
    acessToken: null,
    user: {},
    prices: {},
    wallet: [],
    myNumberList: [],
    pli: null,
    plp: null,
    test: '',
    staking: { staking: { sum: 10000 } },
    lotto_price: 25
  },
  getters: {
    staff : (state) => ( location.href.indexOf('lassa') > -1 || location.href.indexOf('localhost') > -1  ) , 
    // staff : (state) => ( false ) , 
    result: (state) => state.result,
    wlabel: (state) => state.wlabel, 

    toast: (state) => state.toast,
    modal: (state) => state.modal,
    loading: (state) => state.loading,
    is_login: (state) => state.is_login,
    activeMenu: (state) => state.activeMenu,
    acessToken: (state) => state.acessToken,
    user: (state) => state.user,
    prices: (state) => state.prices,
    wallet: (state) => state.wallet,
    myNumberList: (state) => state.myNumberList,
    pli: (state) => state.pli,
    plp: (state) => state.plp,
    lotto_price: (state) => state.lotto_price,
    staking: (state) => state.staking
  },
  mutations: {     
    wlabel : function(state) { 

      if(  location.href.indexOf('web3pays') > -1 )  {
          state.wlabel  = {
                logo  : 'logo-web3pays.svg' , 
                name  : 'Web3pays' , 
          }
      } 
    } , 
    staff : function  (state, staff) {
       state.staff = ( location.href.indexOf('lassa') > -1 || location.href.indexOf('localhost') > -1  )? true :false          
    },        
    result: function (state, result) {
      state.result = result
    },    
    toast: function (state, toast) {
      state.toast = toast
    },
    modal: function (state, modal) {
      state.modal = modal
    },
    is_login: function (state, is_login) {
      state.is_login = is_login
    },
    loading: function (state, loading) {
      state.loading = loading
    },
    activeMenu: function (state, activeMenu) {
      state.activeMenu = activeMenu
    },
    MUTATION_LOGIN: function (state, acessToken) {
      state.acessToken = acessToken
      // localStorage.acessToken = acessToken
    },
    MUTATION_LOGOUT: function (state) {
      state.acessToken = null
      state.is_login = false
      VueCookies.remove('asp')
      delete localStorage.accessToken
    },
    SET_USERINFO: function (state, user) {
      state.user = user
    },
    SET_PRICES: function (state, data) {
      state.prices = data
    },
    SET_WALLET: function (state, data) {
      state.wallet = data
    },
    SET_STAKINGINFO: function (state, data) {
      state.staking = data
    },
    w_l_lotto_user_num: function (state, data) {
      state.myNumberList = data
    },
    setStBalance: function (state, data) {
      state.pli = data
    },
    setPlpBalance: function (state, data) {
      state.plp = data
    },
    lotto_price: function (state, data) {
      state.lotto_price = data
    }
  },
  actions: {    
 
    toast({ commit }, params) {
      commit('toast', params)
    },
    modal({ commit }, params) {
      commit('modal', params)
    },  
    MARKET_ACT({ commit }, params ) {   
      return market_act(params)
      .then((response) => {
        if( params.proc =='submit' ) {           
          return new Promise((resolve, reject) => {
            if (response.data.status) { 
              commit('result', response.data )   
              resolve(response.data)
            } else {
              resolve(response.data)
            }
          }) ;  

        }else {
          return response ; 
        } ; 
      })
      .catch((error) => error) ;  
  } ,         
    STAFF_ACT({ commit }, params ) {   
      return staff_act(params)
      .then((response) => {
        if( params.proc =='submit' ) {
          
          return new Promise((resolve, reject) => {
            if (response.data.status) {
             // const token = response.data.token
             // commit('is_login', true)
             // commit('MUTATION_LOGIN', token)
              commit('result', response.data )   
              resolve(response.data)
            } else {
              resolve(response.data)
            }
          }) ; 


        }else {
          return response ; 
        } ; 
      })
      .catch((error) => error) ;  
  } ,       
    AUTH_CODE({ commit }, params ) {

        return auth_code(params)
        .then((response) => {
          if( params.proc =='submit' ) {
            
            return new Promise((resolve, reject) => {
              if (response.data.status) {
                const token = response.data.token
                commit('is_login', true)
                commit('MUTATION_LOGIN', token)
                resolve(response.data)
              } else {
                resolve(response.data)
              }
            }) ; 


          }else {
            return response ; 
          } ; 
        })
        .catch((error) => error) ; 
 

    } , 
    LOGING({ commit }, params) {
      return loginG(params)
        .then((response) => {
          return new Promise((resolve, reject) => {
            if (response.data.status) {
              const token = response.data.token
              commit('is_login', true)
              commit('MUTATION_LOGIN', token)
              resolve(response.data)
            } else {
              resolve(response.data)
            }
          })
        })
        .catch((error) => error)
    },

    LOGIN({ commit }, params) {
      return login(params)
        .then((response) => {
          return new Promise((resolve, reject) => {
            if (response.data.status) {
              const token = response.data.token
              commit('is_login', true)
              commit('MUTATION_LOGIN', token)
              resolve(response.data)
            } else {
              resolve(response.data)
            }
          })
        })
        .catch((error) => error)
    },
    LOGOUT({ commit }) {
      commit('MUTATION_LOGOUT')
    },
    SIGNUP(context, params) {
      return signup(params).then((response) => {
        if (response.data.status) {
          //가입 성공 처리 로직
        }
        return response
      })
    },
    VERIFY_EMAIL(context, params) {
      return verify(params).then((response) => {
        if (response.status === 200) return response.data
        return response
      })
    },
    SEND_VERIFY_CODE(context, params) {
      return sendVerifyCode(params).then((response) => {
        // console.log(response);
        return response
      })
    },
    GETGAS(context) {
      return getGas().then((response) => {
        // console.log("GETGAS :: ", response);
        if( response.data && response.data.message == 'OK' ) {
          response.data.fast = response.data.result.FastGasPrice ; 
        }
        return response
      })
    },
    AVAIL_TOKEN(context, params) {
      return available_token(params).then((response) => {
        //console.log("res.data", response);
        return response
      })
    },
    W_SEND(context, params) {
      return wallet_send(params).then((response) => {
        // console.log('res.data', response);
        return response
      })
    },
    FETCH_USERINFO({ commit }) {
      return userInfo().then((response) => {
        //  console.log( "response.data.user"  , response.data.user )
        if (response.status === 200) commit('SET_USERINFO', response.data.user)
        return response
      })
    },
    FETCH_STAKINGINFO({ commit }) {
      return api_staking().then((response) => {
        if (response.status === 200) commit('SET_STAKINGINFO', response.data)
        return response
      })
    },
    FETCH_PRICES({ commit }) {
      // console.log( 'SET_PRICES :: FETCH_PRICES'  ) ;

      return getTokenPrice().then((response) => {
        
        // console.log( 'SET_PRICES :: load'  ) ;

        if (response.status === 200) {
          const tmp = { ...response.data, price_pli: response.data.price_plp }
          // console.log( 'SET_PRICES :: ', tmp ) ;
          commit('SET_PRICES', tmp)
        }
      })
    },
    async getTokenBalance({ commit }, params) {
      if (params.name === 'ETH') {
        const response = await getEthBalance(this.state.user.wallet_address)
        return response
      }
      // console.log('INFURA!!')
      const response = await getTokenBalance(
        params.contract,
        this.state.user.wallet_address
      )
      if (params.name === 'PLP') {
        commit('setPlpBalance', response)
      }
      return response
    },
    async GET_RAW_TX(context, params) {
      const response = await getRawTx(this.state.user.wallet_address, params)
      return response
    },
    async raw_tx_admin(context, params) {
      return this.dispatch('api_config', {
        column: ['id', 'admin_address']
      })
        .then((response) => {
          return getRawTx(response.data.admin_address, params)
        })
        .catch((error) => {
          return new Error(error)
        })
    },
    async FETCH_WALLET({ commit }) {
      // const items = [
      //   { name: 'ETH', contract: '', value: 'eth' },
      //   {
      //     name: 'PLP',
      //     contract: config.plp_addr,
      //     value: 'plp'
      //   },
      //   {
      //     name: 'PLI',
      //     contract: '',
      //     value: 'pli'
      //   },
      //   {
      //     name: 'USDT',
      //     contract: config.usdt_addr,
      //     value: 'usdt'
      //   }
      // ]
      // let _wallet = []

      // for (var item of items) {
      //   if (item.name === 'PLI') {
      //     await this.dispatch('balance_pli')
      //       .then(() => {
      //         return this.dispatch('w_r_my_point')
      //       })
      //       .then((response) => {
      //         _wallet.push({
      //           name: item.name,
      //           price: this.state.prices[`price_plp`] || 0,
      //           balance: response.data.result || '0',
      //           value: item.value
      //         })
      //       })
      //   } else {
      //     await this.dispatch('getTokenBalance', item).then((response) => {
      //       _wallet.push({
      //         name: item.name,
      //         price: this.state.prices[`price_${item.value}`] || 0,
      //         balance: response || 0,
      //         value: item.value
      //       })
      //     })
      //   }
      // }

//  console.log( "this.state.user ss:: " , this.state.user.id  )  

//       let params =  {
//           user_id : this.state.user.id
//       }
      const _wallet = await balance_all().then((res) => {
        return res.data.wallet.filter(
          (i) => i.name !== 'PLP' && i.name !== 'PLI'
        )
      })
      // .then((res)=>{
      //   // this.state.user. console.log( "_wallet ss:: " , res )  
      //   res.map(function(obj){
      //     if(obj.name == "EUR") { 

      //        obj.balance =  card_info(params)   
      //         .then((response) => {
      //           console.log("response : " , response ) ;
      //           return response.data.balance
      //         })
      //         .catch((error) => {
      //           console.log("error :: " , error ) ; 
      //           return 0 ; 
      //         })

      //     } ;           
      //   })

      //   return res ; 
      // })

      // console.log( "_wallet:: " , _wallet )

      commit('SET_WALLET', _wallet)

      return _wallet
    },
    w_l_contents({ commit} , params) {
      return w_l_contents(params).then((response) => {
        // console.log(response);
        return response.data
      })
    },
    api_config({ commit }, params) {
      return api_config(params).then((response) => {
        // console.log(response);
        return response
      })
    },
    user_swap({ commit }, params) {
      return user_swap(params).then((response) => {
        // console.log(response);
        return response
      })
    },
    user_lockup_list({ commit }) {
      return user_lockup_list().then((response) => response)
    },
    w_l_lotto_user_num({ commit }) {
      return w_l_lotto_user_num().then((response) => {
        commit('w_l_lotto_user_num', response.data)
        return response
      })
    },
    w_cu_lotto_user_num({ commit }, params) {
      return w_cu_lotto_user_num(params).then((response) => {
        // console.log(response)
        return response
      })
    },
    w_d_lotto_user_num({ commit }, params) {
      return w_d_lotto_user_num(params).then((response) => {
        // console.log(response)
        return response
      })
    },
    w_l_lotto_num({ commit }) {
      return w_l_lotto_num().then((response) => {
        // console.log(response)
        return response
      })
    },
    w_lotto_home({ commit }) {
      return w_lotto_home().then((response) => {
        // console.log(response)
        return response
      })
    },
    w_l_lotto_no({ commit }) {
      return w_l_lotto_no().then((response) => {
        // console.log(response)
        return response
      })
    },
    w_lotto_order_result({ commit }, params) {
      return w_lotto_order_result(params).then((response) => {
        // console.log(response)
        return response
      })
    },
    w_c_lotto_order({ commit }, params) {
      return w_c_lotto_order2(params).then((response) => {
        // console.log(response)
        return response
      })
    },
    w_l_lotto_amt({ commit }) {
      return w_l_lotto_amt().then((response) => {
        // console.log(response)
        return response
      })
    },
    getTxHistoryEth({ commit }, params) {
      return getTxHistoryEth(params.walletAdress, params.page).then(
        (response) => {
          // console.log(response)
          return response
        }
      )
    },
    getTxHistoryErc({ commit }, params) {
      return getTxHistoryErc(params.walletAdress, params.page).then(
        (response) => {
          // console.log(response)
          return response
        }
      )
    },
    checkAddress({ commit }, params) {
      return check_address(params).then((response) => response)
    },
    my_l_attend({ commit }, params) {
      return my_l_attend(params).then((response) => response)
    },
    my_l_recommend({ commit }, params) {
      return my_l_recommend(params).then((response) => response)
    },
    my_point_history({ commit }, params) {
      return my_point_history(params).then((response) => response)
    },
    w_r_my_point({ commit }) {
      return w_r_my_point().then((response) => response)
    },
    balance_pli({ commit }) {
      return balance_pli().then((response) => {
        if (response.data && response.data.status)
          commit('setStBalance', response.data.balance)
        return response
      })
    },
    exchange_pli({ commit }, params) {
      return exchange_pli(params).then((response) => response)
    },
    lotto_order({ commit }, params) {
      return lotto_order(params).then((response) => response)
    },
    withdraw({ commit }) {
      return withdraw().then((response) => response)
    },
    async lotto_price({ commit }) {
      const response = await lotto_price()
      commit('lotto_price', response.data.price)
      return response
    },
    send_transaction({ commit }, params) {
      return send_transaction(params).then((response) => response)
    },
    send_transaction_tron({ commit }, params) {
      return send_transaction_tron(params).then((response) => response)
    },
    send_transaction_w3p({ commit }, params) {
      return send_transaction_w3p(params).then((response) => response)
    },    

    auth_sms({ commit }, params) {
      return auth_sms(params).then((response) => response)
    },
    auth_sms_confirm({ commit }, params) {
      return auth_sms_confirm(params).then((response) => response)
    },
    auth_sms_complete({ commit }, params) {
      return auth_sms_complete(params).then((response) => response)
    },
    mailcheck({ commit }, params) {
      return mailcheck(params).then((response) => response)
    },
    register_push({ commit }, params) {
      return register_push(params).then((response) => response)
    },
    w_l_popup({ commit }) {
      return w_l_popup().then((response) => response)
    },
    user_attend({ commit }) {
      return user_attend().then((response) => response)
    },
    staking_token({ commit }, params) {
      return staking_token(params).then((response) => response)
    },
    psite() {
      return psite().then((response) => response)
    },
    event_add() {
      return event_add().then((response) => response)
    }, 
    auth_code({ commit } , params ) {
      return auth_code(params).then((response) => response)
    },    
    authsend({ commit }, params) {
      return authsend(params).then((response) => response)
    },
    nft_proc({ commit }, params ) {
      return nft_proc(params).then((response) => response)
    },
    market_payed({ commit }, params ) {
      return market_payed(params).then((response) => response)
    },
    
    // cards!!
    kyc_req({ commit }, params ) {
      return kyc_req(params).then((response) => response)
    },
    kyc_chk({ commit }, params ) {
      return kyc_chk(params).then((response) => response)
    },
    card_activa({ commit }, params ) {
      return card_activa(params).then((response) => response)
    },
    card_info({ commit }, params ) {
      // console.log( "params"  , params )
      
      return card_info(params).then((response) => response)
    },
    recharge({ commit }, params ) {
      return recharge(params).then((response) => response)
    },
    recharge_chk({ commit }, params ) {
      return recharge_chk(params).then((response) => response)
    },
    tradeHistory({ commit }, params ) {
      return tradeHistory(params).then((response) => response)
    },
    card_order({ commit }, params ) {
      return card_order(params).then((response) => response)
    }, 
    // End cards!!

  },
  modules: {}
})
